/**
 * Tipos de toma de pared: `value` es lo que se guarda, `label` lo que se lee.
 *
 * Vive en `config/` y no dentro de un componente porque lo usan tres sitios a
 * la vez (el filtro del listado, la ficha y la tabla del alta masiva). Si
 * estuviera exportado desde el listado, el diálogo y el listado se importarían
 * en círculo.
 */
export const OUTLET_TYPES = [
  { value: 'rj45',      label: 'RJ45' },
  { value: 'rj45x2',    label: 'RJ45 doble' },
  { value: 'fiber_sc',  label: 'Fibra SC' },
  { value: 'fiber_lc',  label: 'Fibra LC' },
  { value: 'fiber_mtp', label: 'Fibra MTP' },
];

export const tipoEtiqueta = (valor) =>
  OUTLET_TYPES.find((t) => t.value === (valor || 'rj45'))?.label || valor || 'RJ45';
